import config from '@/config'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

var mixin = {
	data() {
		return {
			methods: {
				checkconection: 'auth/checkconection',
				getMenuConfig: 'auth/getMenuConfig',
				searching: false,
				qRowsDefault: 25,
			},
			menuConfig: [],
			searchQuery: [{ column: 'id', numeric: true, default: -1 }],
			months: [
				{ id: 1, name: 'Enero', abbreviated: 'Ene' },
				{ id: 2, name: 'Febrero', abbreviated: 'Feb' },
				{ id: 3, name: 'Marzo', abbreviated: 'Mar' },
				{ id: 4, name: 'Abril', abbreviated: 'Abr' },
				{ id: 5, name: 'Mayo', abbreviated: 'May' },
				{ id: 6, name: 'Junio', abbreviated: 'Jun' },
				{ id: 7, name: 'Julio', abbreviated: 'Jul' },
				{ id: 8, name: 'Agosto', abbreviated: 'Ago' },
				{ id: 9, name: 'Septiembre', abbreviated: 'Sep' },
				{ id: 10, name: 'Octubre', abbreviated: 'Oct' },
				{ id: 11, name: 'Noviembre', abbreviated: 'Nov' },
				{ id: 12, name: 'Diciembre', abbreviated: 'Dic' }
			],
			searchGeneral: '',
			needGenesys: false,
			rolesFullAction: [1],
			loadingConfigurations: false
		}
	},
	computed: {
		...mapGetters(['getApiBackend', 'getCommands', 'getConnected', 'getEnvironment', 'getEnvironmentCurrent', 'getHeaders', 'getHistory', 'getHistoryInput', 'getMenu', 'getNameApp', 'getToken', 'getUrl', 'getUser', 'getUrlImagen']),
		...mapState(['apiBackend', 'auth', 'environment', 'greeted', 'headerModule', 'headers', 'io', 'messageLockScreen', 'menuLeft', 'role', 'socketioConnect', 'web', 'container'])
	},
	filters: {
		capitalize: function (value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		},
		formatNumber(val) {
			return this.methodFormatNumber(val)
		},
		formatPercentage(val) {
			return this.methodFormatNumber(val, 2) + "%"
		},
		formatMoney(val) {
			val = parseInt(val)
			return this.methodFormatMoney(val)
		},
		formatDate(dateTime) {
			if (dateTime == undefined)
				return ''
			dateTime = dateTime.split('T')
			if (dateTime.length == 1) {
				dateTime = dateTime[0].split(' ')
			}
			let date = dateTime[0].split('-')
			date = date[2] + '-' + date[1] + '-' + date[0]
			let time = (dateTime[1].substring(0, 8) == '00:00:00') ? '' : dateTime[1].substring(0, 8)
			return date + ' ' + time
		},
		dateZ(val) {
			let data = val.split('T')
			return data[0] + ' ' + data[1].substring(0, 8)
		}
	},
	methods: {
		...mapActions(['setHeadersAuthorization', 'getMenuLeft']),
		...mapMutations(['setApiBackend',
			'setAuth',
			'setCommandGeneral',
			'setCommandModule',
			'setCommandSystem',
			'setCloseBtnEnableLockScreen',
			'setEnvironment',
			'setFavorite',
			'setGreeted',
			'setHeaderModule',
			'setHeadersAuthorization',
			'setHistoryInput',
			'setHistoryInputEmpty',
			'setInitialized',
			'setIconClassLockScreen',
			'setMenu',
			'setMessageLockScreen',
			'setRole',
			'setSocket',
			'setSocketioConnect',
			'setShowLockScreen',
			'setSubTitleModule',
			'setTextColorLockScreen',
			'setTitleModule',
			'setSocketFacturacionCLConnect',
			'setWeb',
			'setUser',
			'setToken',
			'sendMessageSocketPHP']),
		analyzeSearch(search) {
			let array = search.split('=')
			if (array.length == 2) {
				let index = this.searchQuery.map((el) => el.column).indexOf(array[0])
				if (index > -1) {
					if (this.searchQuery[index].numeric) {
						return (!isNaN(array[1]) && array[1].trim() != '') ? '' : search
					}
				}
			}
			return search
		},
		analyzeSearchGeneral(search) {
			if (search.trim().length > 0) {
				if (!isNaN(search)) {
					if (search.length != 13) {
						this.analyzeSearchGeneralResultNumber(search)
						return true
					} else {
						let a = { value: search.trim() }
						this.analyzeSearchGeneralResultProduct(a)
						return true
					}
				} else {
					let v = search.substring(0, 1)
					if (v.toUpperCase() == 'H') {
						v = search.substring(1, search.trim().length)
						if (!isNaN(v)) {
							let a = { value: v.trim() }
							this.analyzeSearchGeneralResultProduct(a)
							return true
						} else {
							v = v.split('x')
							if (v.length > 1 && v[0].trim().length > 0 && !isNaN(v[0]) && v[1].trim().length > 0 && !isNaN(v[1])) {
								let a = { value: v[0].trim(), quantity: parseInt(v[1]) }
								this.analyzeSearchGeneralResultProduct(a)
								return true
							}
						}
					}
					v = search.substring(0, 2)
					let v1 = search.trim().substring(2, search.length)
					if (v.toUpperCase() == 'SE' && search.trim().length > 2 && !isNaN(v1)) {
						if (v1.length == 16 || v1.length == 20) {
							this.analyzeSearchGeneralResultSE(v1)
							return true
						}
					}
					if (v.toUpperCase() == 'MA' && search.trim().length > 2 && !isNaN(v1)) {
						if (v1.length == 9) {
							this.analyzeSearchGeneralResultMA(v1)
							return true
						}
					}
					if (v.toUpperCase() == 'OR' && search.trim().length > 2 && !isNaN(v1)) {
						this.analyzeSearchGeneralResultOR(v1)
						return true
					}
					if (v.toUpperCase() == 'WEB' && search.trim().length > 2 && !isNaN(v1)) {
						this.analyzeSearchGeneralResultWEB(v1)
						return true
					}
				}
				this.analyzeSearchGeneralResultString(search)
				return true
			}
			return false
		},
		analyzeSearchGeneralResultNumber(result) /** Numero */ { alert('Esto (' + result + ') es un número, no está configurado lo que vamos a hacer con el') },
		analyzeSearchGeneralResultProduct(result) /** Producto (HNNN, HNNNxNN, NNNNNNNNNNNNN) */ { alert('Esto (' + result.value + ') es producto, no está configurado lo que vamos a hacer con el'); console.log(result) },
		analyzeSearchGeneralResultSE(result) /** Solicitud de Envío (SENNNNNNNNNNNNNNNNNNNN)*/ { alert('Esto (' + result + ') es una Solicitud de Envío') },
		analyzeSearchGeneralResultMA(result) /** Manifiesto (MANNNNNNNNN) */ { alert('Esto (' + result + ') es un Manifiesto') },
		analyzeSearchGeneralResultOR(result) /** Orden (ORNNNNNNNNNN) */ { alert('Esto (' + result + ') es una Orden de Pedido') },
		analyzeSearchGeneralResultWEB(result) /** Pedido WEB (WEBNNNNNNNNNN) */ { alert('Esto (' + result + ') es un Pedido WEB') },
		analyzeSearchGeneralResultString(result) /** String */ { alert('Esto (' + result + ') es un string') },
		axiosActionIS(url, method, responseLocal, data = []) {
			if (this.setAuthorizationBackend()) {
				this.axiosAction(url, method, this.getHeaders, responseLocal, data)
			}
		},
		btnHideLockScreen() {
			this.$refs.lockScreen.$refs.btnHideLockScreen.click()
		},
		btnShowLockScreen() {
			this.$refs.lockScreen.$refs.btnShowLockScreen.click()
		},
		changeEnvironment() {
			if (this.getEnvironment == 'development') {
				if (confirm('¿Quiere cambiar de fuentes de datos?\nTendrá que loguearse nuevamente')) {
					let environment = localStorage.getItem('environment')
					if (environment == 'production') {
						localStorage.removeItem('environment')
					} else {
						localStorage.setItem('environment', 'production')
					}
					if (this.$router.history.current.fullPath != '/login') {
						localStorage.setItem('redirect', this.$router.history.current.fullPath)
						window.location.href = '/'
					} else {
						window.location.href = '/login'
					}
				}
			}
		},
		checkConection() {
			if (this.setAuthorizationBackend()) {
				this.axios
					.get(this.apiBackend + this.methods.checkconection, {
						headers: this.headers
					})
					.then(response => {
						if (this.auth.length == 0 && this.io !== []) {
							this.setAuth(response.data.auth)
						}
						this.iniConfigAuth()
						this.greet()
						console.log('Conexión verificada!!!')
					})
					.catch(error => {
						this.showLockScreen('Error de autentificación, está siendo redirigido a la página autentificación', '', 'text-dark')
						setTimeout(() => { this.hideLockScreen(); this.$router.push('login') }, 2000)
						this.errorHttpHandling(error)
					})
			}
		},
		checkDigitoRUT(stringRUT) {
			if (stringRUT === null) {
				return false
			}
			stringRUT = stringRUT.replaceAll('.', '')
			let soloRUT = stringRUT.split('-')
			if (soloRUT.length != 2)
				return false //El Formato del rut es invalido
			let digito = this.searchDigitoRUT(soloRUT[0])
			return (String(digito).toUpperCase() == String(soloRUT[1]).toUpperCase())
		},
		cleanedStringZPL(cadena) {
			var specialChars = "º°";

			// Los eliminamos todos
			for (var i = 0; i < specialChars.length; i++) {
				cadena = cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
			}
			cadena = cadena.replace(/á/gi, "a");
			cadena = cadena.replace(/é/gi, "e");
			cadena = cadena.replace(/í/gi, "i");
			cadena = cadena.replace(/ó/gi, "o");
			cadena = cadena.replace(/ú/gi, "u");
			cadena = cadena.replace(/ñ/gi, "n");
			return cadena;
		},
		clearConsole() {
			//console.clear()
			let e = "font-size:25px; font-family: 'Oswald', sans-serif; color: black;"
			console.info("%ciSystem 4%c - Laravel", e + "color: #38a8af;", "color: black;")
		},
		infoConsole(data) {
			console.log(data)
		},
		confirmResponse(response) {
			if (!response.data.success) {
				if (response.data.success == false)
					this.$snotify.error(response.data.data, response.data.message)
				else {
					this.$snotify.error('Error de formato de respuesta', 'Error')
					console.log(response)
				}
				return false
			}
			return response.data.success
		},
		console(message) {
			if (config.ENVIRONMENT == 'DEV')
				console.log(message)
		},
		copyClipboard(str) {
			const el = document.createElement('textarea');
			el.value = str;
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);
		},
		currentDate(days = 0, time = false) {
			let today = new Date();

			today.setDate(today.getDate() + days);

			let dd = today.getDate();
			let mm = today.getMonth() + 1; //January is 0!
			let yyyy = today.getFullYear();

			dd = (dd < 10) ? '0' + dd : dd;
			mm = (mm < 10) ? '0' + mm : mm;

			let current = yyyy + '-' + mm + '-' + dd;

			if (time) {
				let hh = today.getHours()
				let mm_ = today.getMinutes()
				let ss = today.getSeconds()
				hh = (hh < 10) ? '0' + hh : hh;
				mm_ = (mm_ < 10) ? '0' + mm_ : mm_;
				ss = (ss < 10) ? '0' + ss : ss;

				current += ' ' + hh + ':' + mm_ + ':' + ss
			}
			return current;
		},
		downloadPDF(url) {
			window.open(url, 'Download');
		},
		fill(number, width) {
			let numberOutput = Math.abs(number); /* Valor absoluto del número */
			let length = number.toString().length; /* Largo del número */
			let zero = "0"; /* String de cero */

			if (width <= length) {
				if (number < 0) {
					return ("-" + numberOutput.toString());
				} else {
					return numberOutput.toString();
				}
			} else {
				if (number < 0) {
					return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
				} else {
					return ((zero.repeat(width - length)) + numberOutput.toString());
				}
			}
		},
		formatRUT(stringRUT, point = '.') {
			if (stringRUT == null) {
				return 'NOT VALID'
			}
			stringRUT = stringRUT.replaceAll('.', '')
			stringRUT = stringRUT.replaceAll('-', '')
			if (!this.checkDigitoRUT(stringRUT)) {
				stringRUT = stringRUT.substring(0, stringRUT.length - 1) + '-' + stringRUT.substring(stringRUT.length - 1, stringRUT.length)
				if (!this.checkDigitoRUT(stringRUT)) {
					stringRUT = 'NOT VALID'
				}
			}
			if (stringRUT != 'NOT VALID') {
				let stringRUTArray = stringRUT.split('-')
				let resto = stringRUTArray[0].length % 3
				let threesomes = (resto == 0) ? Math.trunc(stringRUTArray[0].length / 3) - 1 : Math.trunc(stringRUTArray[0].length / 3)
				for (let i = 0; i < threesomes; i++) {
					stringRUTArray[0] = stringRUTArray[0].substring(0, stringRUTArray[0].length - (3 * (i + 1)) - i) + '.' + stringRUTArray[0].substring(stringRUTArray[0].length, stringRUTArray[0].length - (3 * (i + 1)) - i)
				}
				stringRUT = stringRUTArray[0] + '-' + stringRUTArray[1]
			}
			return stringRUT
		},
		getMenuConfig(id) {
			let param = '?menu_id=' + id
			this.axiosActionIS(this.apiBackend + this.methods.getMenuConfig + param, 'GET', 'getMenuConfigResult')
		},
		getMenuConfigResult(response) {
			if (response.data.success) {
				this.menuConfig = response.data.data
				this.setHeaderModule({ id: this.menuConfig.menu_id, titleModule: this.menuConfig.name, subTitleModule: this.menuConfig.description, favorite: this.menuConfig.favorite })
				this.initModuleLocal()
			} else {
				this.showLockScreen('No tiene autorización, está siendo redirigido a la página inicial', '', 'text-dark')
				setTimeout(() => { this.hideLockScreen(); this.$router.push('/') }, 2000)
			}
		},
		greet() {
			if (!this.greeted && Object.keys(this.auth).length > 0) {
				//this.io.emit('connect_user', { idUser: this.auth.id, name: this.auth.name })
				//this.setGreeted(true);
			}
		},
		goLogin() {
			this.hideLockScreen()
			this.$router.push('/login')
		},
		goPush(path) {
			if (path != '' && this.$router.history.current.fullPath != path) {
				this.$router.push(path)
			}
		},
		hideLockScreen() {
			if (this.$refs.lockScreen === undefined) {
				this.$emit('hideLockScreen')
			} else {
				this.btnHideLockScreen()
			}
		},
		infoAPP() {
			this.clearConsole()
			this.initSetup()
		},
		iniGeneral() {
			this.setAuthorizationBackend()
			this.setEnvironment(config.ENVIRONMENT)
			this.setApiBackend(this.getApiBackend)
			this.setWeb(this.getUrl)
		},
		initLayout() {
			this.infoAPP()
			this.initLayoutLocal()
		},
		initModule() {
			this.loadingConfigurations = true
			this.iniGeneral()
			if (this.$router.history.current.meta.menu_id !== undefined) {
				this.getMenuConfig(this.$router.history.current.meta.menu_id)
			} else {
				this.setHeaderModule({ id: 0, titleModule: '', subTitleModule: '', favorite: false })
				this.initModuleLocal()
			}
		},
		initSetup() {
			this.iniGeneral()
		},
		isMail(email) {
			var validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
			if (validEmail.test(email)) {
				return true
			}
			return false
		},
		isRoleFullAction() {
			let index = this.rolesFullAction.map(e => parseInt(e)).indexOf(parseInt(this.auth.role_id))
			return (index > -1)
		},
		isObjEmpty(obj) {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) return false;
			}
			return true;
		},
		isInt(n) {
			return Number(n) == n && n % 1 === 0;
		},
		isFloat(n) {
			return Number(n) == n && n % 1 !== 0;
		},
		methodFormatMoney(val) {
			val = parseInt(val)
			return 'CLP$ ' + this.formatNumber(val.toFixed(2))
		},
		methodFormatNumber(amount, decimals = 0, signo = '.') {

			amount += ''; // por si pasan un numero en vez de un string
			amount = parseFloat(amount.replace(/[^0-9\.\-]/g, '')); // elimino cualquier cosa que no sea numero o punto

			decimals = decimals || 0; // por si la variable no fue fue pasada

			// si no es un numero o es igual a cero retorno el mismo cero
			if (isNaN(amount) || amount === 0)
				return parseFloat(0).toFixed(decimals);

			// si es mayor o menor que cero retorno el valor formateado como numero
			amount = '' + amount.toFixed(decimals);

			var amount_parts = amount.split('.'),
				regexp = /(\d+)(\d{3})/;

			while (regexp.test(amount_parts[0]))
				amount_parts[0] = amount_parts[0].replace(regexp, '$1' + signo + '$2');

			return amount_parts.join('.');
		},
		repeatCharacter(char, length) {
			let result = ''
			for (let index = 0; index < length; index++) {
				result += char;
			}
			return result
		},
		reportGenesys(typeInfo) {
			let param = "?typeInfo=" + typeInfo
			let url = this.getApiBackend + 'genesys/report' + param
			this.axiosActionIS(url, 'GET', 'reportGenesysResult')
		},
		reportGenesysResult(response) {
			if (response.data.success == true) {
				this.needGenesys = response.data.data
			}
			this.reportGenesysResultLocal(response)
		},
		reportGenesysResultLocal(response) {
			console.log('reportGenesysResultLocal no desarrollado', response)
		},
		searchDigitoRUT(stringRUT) {
			if (stringRUT === null)
				return false
			let soloRUT = stringRUT.split("-");
			stringRUT = soloRUT[0];
			stringRUT = stringRUT.split('.').join('');
			stringRUT = stringRUT.split(',').join('');
			let cont = 7;
			let suma = 0;
			if (isNaN(stringRUT))
				return -1; //El Rut contiene valores alfanumericos
			for (let i = stringRUT.length - 1; i > -1; i--) {
				cont = (cont == 7) ? 2 : cont + 1;
				suma += stringRUT[i] * cont;
			}
			return (11 - (suma % 11) == 10) ? 'K' : ((11 - (suma % 11) == 11) ? '0' : (11 - (suma % 11)));
		},
		setAuthorizationBackend() {
			this.headers.Authorization = 'Bearer ' + localStorage.token
			return true
		},
		sleep(milliseconds) {
			let start = new Date().getTime();
			for (var i = 0; i < 1e7; i++) {
				if ((new Date().getTime() - start) > milliseconds) {
					break;
				}
			}
		},
		showConsole(item) {
			console.log(item)
		},
		showLockScreen(msg = 'Cargando . . .', iconClass = 'spinner-border', textColor = 'text-white', closeBtnEnable = false) {
			iconClass = (iconClass == '') ? 'spinner-border' : iconClass;
			msg = (msg == '') ? 'Cargando . . .' : msg;
			textColor = (textColor == '') ? 'text-white' : textColor;

			this.setCloseBtnEnableLockScreen(closeBtnEnable)
			this.setIconClassLockScreen(iconClass)
			this.setMessageLockScreen(msg)
			this.setTextColorLockScreen(textColor)

			if (this.$refs.lockScreen === undefined) {
				this.$emit('btnShowLockScreen')
			} else {
				this.btnShowLockScreen()
			}
		},
		socketEmit(event, body = []) {
			if (this.socketioConnect) {
				this.io.emit('message_client', {
					'event': event,
					'body': body
				})
			} else {
				console.info('No se pueden enviar datos por SocketIO')
			}
		},
		stopSound(audio) {
			audio.pause();
			audio.currentTime = 0;
		},
		updateTableGeneral(controller, id, field, value) {
			let url = this.apiBackend + controller + '/' + id + '/updateToField'
			let param = {
				field: field,
				value: value
			}
			this.axiosActionIS(url, 'PUT', 'updateTableGeneralResult', param)
		},
		updateTableGeneralResult(response) {
			this.updateTableGeneralResultLocal(response)
		},
		updateTableGeneralResultLocal(response) {
			console.log('updateTableGeneralResultLocal no desarrollado')
		},
		viewAllItem(item) {
			console.log(item)
		},
		xmlToJson(xml) {
			let convert = require('xml-js');
			let jsonResult = convert.xml2json(xml, { compact: true, spaces: 4 })
			return JSON.parse(jsonResult)
		}
	},
};

export default mixin;